import REDUX_ACTION from 'modules/redux/constants/action'

/**
 * Resets the domain at the given `payload.path`.
 * @param {Object} params={}
 *        {string} params.type
 *        {string} [params.payload]
 *        {string} [params.payload.path]
 *        {string} [params.payload.keysToOmit]
 */

function resetReduxAction (params) {
  return {
    type: params.type,
    reduxType: REDUX_ACTION.RESET,
    payload: params.payload || {}
  }
}

export default resetReduxAction
